<template>
    <div>
        <v-overlay :value="loading">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

        <v-form ref="form" lazy-validation>
            <v-row class="px-4 py-0">
                <!-- First Row -->
                <v-col md="6" sm="6" xs="6" class="pt-0">
                    <v-select
                        :disabled="state != 'Live'"
                        v-model="onBoard.platform"
                        :items="platforms"
                        label="Platform"
                        
                    ></v-select>
                    <v-text-field
                        :disabled="state != 'Live'"
                        v-model="onBoard.salesPerson"
                        label="Sales Person"
                    ></v-text-field>
                    <v-text-field
                        :disabled="state != 'Live'"
                        v-model="onBoard.partnerSource"
                        label="Partner Source"
                    ></v-text-field>
                    <v-text-field
                        :disabled="state != 'Live'"
                        v-model="onBoard.transactionFee"
                        label="Transaction Fee"
                    ></v-text-field>
                    <v-text-field
                        :disabled="state != 'Live'"
                        v-model="onBoard.serviceFee"
                        label="Service Fee"
                    ></v-text-field>
                    <v-text-field
                        :disabled="state != 'Live'"
                        v-model="onBoard.monthlyMinimum"
                        label="Monthly Minimum"
                    ></v-text-field>
                    <v-select
                        :disabled="state != 'Live'"
                        v-model="onBoard.vat"
                        label="VAT"
                        :items="vatOptions"
                    ></v-select>
                    <v-select
                        :disabled="state != 'Live'"
                        v-model="onBoard.gatewayOnly"
                        label="Gateway Only"
                        :items="gatewayOnlyOptions"
                    ></v-select>

                      <v-text-field
                        v-model="onBoard.customerId"
                        label="Sales Force ID"
                    ></v-text-field>

                    <v-combobox
                        v-model="onBoard.division"
                        :disabled="!divisions"
                        :items="divisions"
                        item-text="name"
                        item-value="id"
                        item-key="id"
                        small-chips
                        label="Division Name or UUID"
                        @change="getMerchants($event, 'division')"
                        clearable @click:clear="clearDivision"
                        :rules="rules.characters"
                    ></v-combobox>

                    <v-combobox
                        v-model="onBoard.merchant"
                        :disabled="!onBoard.division"
                        :items="merchants"
                        item-text="name"
                        item-value="id"
                        item-key="id"
                        small-chips
                        label="Merchant Name or UUID"    
                        clearable @click:clear="clearMerchant"
                        :rules="rules.characters"
                    ></v-combobox>

                    <v-text-field
                        :disabled="!onBoard.division || !onBoard.merchant"
                        v-model="onBoard.channel"
                        label="Channel Name"
                        :rules="rules.characters"
                    ></v-text-field>

                    <v-select
                        v-model="onBoard.transactionCategory"
                        :items="transactionCategory"
                        label="Transaction Category"
                        :rules="rules.required"
                    ></v-select>

                    <v-select
                        v-model="onBoard.merchantCategory"
                        :items="merchantCategory"
                        label="Merchant Category"
                        :rules="rules.required"
                    ></v-select>
                </v-col>

                <!-- Second Row -->
                <v-col md="6" sm="6" xs="6" class="pt-0">
                    <v-text-field
                        v-model="onBoard.merchantId"
                        label="Merchant ID"
                        :rules="rules.required"
                    ></v-text-field>

                    <v-text-field
                        v-model="onBoard.terminalId"
                        label="Terminal ID"
                        :rules="rules.required"
                    ></v-text-field>

                    <v-text-field
                        v-model="onBoard.categoryCode"
                        label="Merchant Category Code"
                        :rules="rules.required"
                    ></v-text-field>
                    
                    <v-text-field
                        v-model="onBoard.url"
                        label="URL"
                        :rules="[validUrl]"
                    ></v-text-field>

                    <v-select
                        v-model="onBoard.schemes"
                        label="Payment Schemes"
                        :items="schemes"
                        multiple
                        small-chips
                        :rules="rules.multiple"
                    ></v-select>

                    <v-select
                        v-model="onBoard.currencies"
                        label="Currencies"
                        :items="currencies"
                        multiple
                        small-chips
                        :rules="rules.multiple"
                    ></v-select>

                    <v-text-field
                        v-model="onBoard.email"
                        label="Email"
                    ></v-text-field>

                    <v-text-field
                        v-model="onBoard.firstName"
                        label="First Name"
                    ></v-text-field>

                    <v-text-field
                        v-model="onBoard.surname"
                        label="Surname"
                    ></v-text-field>

                    <v-select
                        v-model="onBoard.recType"
                        label="Recurring Type"
                        :items="recurringTypes"
                        multiple
                        small-chips
                        hint='For "All Transactions" recurring type leave blank'
                        persistent-hint
                    ></v-select>

                    <v-select
                        v-model="onBoard.threeD"
                        label="3D Secure"
                        :items="threeDTypes"
                        multiple
                        small-chips
                        :rules="rules.multiple"
                    ></v-select>
                </v-col>
            </v-row>

            <v-divider></v-divider>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="board">Create</v-btn>
            </v-card-actions>

            <!-- Schedule Summary -->
            <onboarder-response
                :visible="dialog"
                :report="report"
                @close="dialog = $event"
            ></onboarder-response>
        </v-form>
    </div>
</template>

<script>
import axios from 'axios';
import OnBoarderResponse from '@/components/onboarder/OnBoarderResponse.vue';

export default {
    props: {
        clearingInstitute: String,
        state: String
    },
    components: {
        'onboarder-response': OnBoarderResponse
    },
    data() {
        return {
            rules: { required: [ v => !!v || 'Required' ],
                     multiple: [ v => v.length == 0 ? 'Required' : true ],
                     email: [ v => this.emailRule(v) ],
                     characters: [ v => this.characterRule(v) ]
                    },
            onBoard: { transactionCategory: 'ECOMMERCE',
                       merchantCategory: 'RETAIL',
                       url: 'www.',
                       customerId: null, // Sales Force ID
                       gatewayOnly: 0 },
            vatOptions: [{ value: 0.00, text: '0%'},
                         { value: 0.20, text: '20%'}],
            gatewayOnlyOptions: [{ value: 0, text: 'No'},
                                 { value: 1, text: 'Yes'}],
            schemes: [{ value: 'MASTER', text: 'Mastercard'},
                      { value: 'VISA', text: 'Visa'}],
            recurringTypes: [{ value: 'nonrec', text: 'Non-Recurring'},
                             { value: 'rec', text: 'Recurring'}],
            threeDTypes: [{ value: 'non3d', text: 'Non-3D'},
                          { value: '3d', text: '3D'},
                          { value: '3dv2', text: '3D v2'}],
            currencies: [{ value: 'AED', text: 'AED' },
                         { value: 'AUD', text: 'AUD' },
                         { value: 'CAD', text: 'CAD' },
                         { value: 'COP', text: 'COP' },
                         { value: 'CHF', text: 'CHF' },
                         { value: 'CZK', text: 'CZK' },
                         { value: 'DKK', text: 'DKK' },
                         { value: 'EUR', text: 'EUR' },
                         { value: 'GBP', text: 'GBP' },
                         { value: 'HKD', text: 'HKD' },
                         { value: 'HUF', text: 'HUF' },
                         { value: 'INR', text: 'INR' },
                         { value: 'JPY', text: 'JPY' },
                         { value: 'KRW', text: 'KRW' },
                         { value: 'MYR', text: 'MYR' },
                         { value: 'MXN', text: 'MXN' },
                         { value: 'NOK', text: 'NOK' },
                         { value: 'NZD', text: 'NZD' },
                         { value: 'PLN', text: 'PLN' },
                         { value: 'NZD', text: 'NZD' },
                         { value: 'RON', text: 'RON' },
                         { value: 'RUB', text: 'RUB' },
                         { value: 'SEK', text: 'SEK' },
                         { value: 'SGD', text: 'SGD' },
                         { value: 'THB', text: 'THB' },
                         { value: 'TRY', text: 'TRY' },
                         { value: 'TWD', text: 'TWD' },
                         { value: 'USD', text: 'USD' },
                         { value: 'ZAR', text: 'ZAR' }],
            transactionCategory: [{ value: 'ANY', text: 'ANY' },
                                  { value: 'ECOMMERCE', text: 'ECOMMERCE' },
                                  { value: 'MOTO', text: 'MOTO'}],
            merchantCategory: [{ value: 'RETAIL', text: 'RETAIL' },
                               { value: 'SERVICES', text: 'SERVICES' },
                               { value: 'AIRLINE', text: 'AIRLINE'},
                               { value: 'HOTEL', text: 'HOTEL'},
                               { value: 'TRAVEL', text: 'TRAVEL'},
                               { value: 'GAMING', text: 'GAMING'},
                               {  value: 'GAMBLING', text: 'GAMBLING'},
                               { value: 'DIGITAL_CONTENT', text: 'DIGITAL_CONTENT'},
                               { value: 'AUCTION', text: 'AUCTION'},
                               { value: 'ADULT', text: 'ADULT'},
                               { value: 'UTILITIES', text: 'UTILITES'},
                               { value: 'E_TICKETING', text: 'E_TICKETING'},
                               { value: 'ONLINE_FINANCIAL', text: 'ONLINE_FINANCIAL'}],
            divisions: null,
            merchants: null,
            loading: false,
            merchantId: null,
            report: null,
            dialog: false,
            platforms: [{ value: 'Bespoke', text: 'Bespoke' },
                        { value: 'Magento', text: 'Magento' },
                        { value: 'Shopify', text: 'Shopify' },
                        { value: 'Woocommerce', text: 'Woocommerce' }]
        }
    },
    beforeMount() {
        this.listDivisions();
        
        if(this.state == 'Test') {
            this.onBoard.division = null;
            this.onBoard.merchantId = '123456';
            this.onBoard.terminalId = '75600001';
            this.onBoard.categoryCode = '5651';
            this.onBoard.schemes = ['VISA', 'MASTER'];
            this.onBoard.currencies = ['GBP', 'EUR', 'USD'];
            this.onBoard.recType = ['nonrec', 'rec'];
            this.onBoard.threeD = ['non3d', '3d'];
        }
    },
    methods: {
        listDivisions() {
            axios({
            method: 'post',
            url: 'list-divisions',
            data: { state: this.state },
            config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
            })
            .then(response => {
                this.divisions = response.data.divisions.filter(division => division.state == 'LIVE')
                                                        .sort((a, b) => a.name.localeCompare(b.name));

                // if(this.state == 'Test') {
                //     this.onBoard.division = this.divisions.find(e => e.name = 'Simple_Division');
                // }
                
                if(this.onBoard.division && this.onBoard.division !== Object(this.onBoard.division)) {
                    this.onBoard.division = response.data.divisions.find(division => division.name == this.onBoard.division);
                    this.listMerchants();
                }
                else if (this.onBoard.division) {
                    this.listMerchants();
                }
            })
            .catch(e => {
                this.errors.push(e)
            })
        },
        listMerchants() {
            axios({
            method: 'post',
            url: 'list-merchants',
            data: { state: this.state, divisionId: this.onBoard.division.id },
            config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
            })
            .then(response => {
                this.merchants = response.data.merchants.filter(merchant => merchant)
                                                        .sort((a, b) => a.name.localeCompare(b.name));

                if(this.onBoard.merchant && this.onBoard.merchant !== Object(this.onBoard.merchant)) {
                    this.onBoard.merchant = response.data.merchants.find(merchant => merchant.name == this.onBoard.merchant);
                }
            })
            .catch(e => {
                this.errors.push(e)
            })
        },
        getMerchants(res, type) {
            if(type == 'division' && res === Object(res)) {
                this.listMerchants();
            }
            else {
                this.merchants = [];
            }
        },
        clearDivision() {
            this.onBoard.merchant = null;
            this.merchants = [];
            this.onBoard.channel = null;
        },
        clearMerchant() {
            this.onBoard.channel = null;
        },
        onReset(e) {
            this.$refs.form.reset();
        },
        emailRule(v) {
            let pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

            if(typeof v !== 'undefined' && v)
            {   if(!pattern.test(v)) {
                    return 'Invalid Email address';
                }
                else { 
                    return true;
                }
            } 
            else {
                return true;
            }
        },
        characterRule(v) {
            let pattern = /^[A-Za-z0-9 -]*$/;
            
            if(v !== Object(v)) {
                if(v) {
                    if(!pattern.test(v)) { 
                        return 'Invalid characters';
                    } else { 
                        return true; 
                    }
                } else {
                    return 'Required';
                }
            } else {
                return true;
            }
        },
        validUrl(e) {
            let pattern = new RegExp(/(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/gi);
            return pattern.test(e) || 'Invalid URL.';
        },
        board() {
            if(this.$refs.form.validate()) {
                this.loading = true;
                axios({
                method: 'post',
                url: 'onboard',
                data: { state: this.state,
                        clearingInstitute: this.clearingInstitute,
                        onBoard: this.onBoard },
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    this.loading = false;
                    this.merchantId = response.data;
                    this.listDivisions();
                    this.getReport();
                })
                .catch(e => {
                    this.loading = false;
                    this.errors.push(e)
                })
            }
        },
        getReport() {
            axios({
            method: 'post',
            url: `full-merchant-data`,
            data: { merchant: this.merchantId,
                    gateId: this.state == 'Live' ? 1 : 2 },
            config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
            })
            .then(response => {
                this.report = response.data;
                this.dialog = true;
            })
            .catch(e => {
                this.errors.push(e)
            })
        },
    }
}
</script>